import React, {ReactElement} from 'react';
import {MS_IN_DAY} from 'shared/const';
import {inclineDays} from 'shared/utils/incline';
import {getTodayStartTime, formatDate, humanizeDate} from 'shared/utils/dateTime';
import {changeTemporaryDate as changeTemporaryDateAction} from 'store/Settings';
import {useDispatch} from 'ui/store';

import {Section} from 'components/Section';
import {Select} from 'components/Select';
import {Control, Prefix, Row} from '../style';

interface Option {
  value: number;
  text: string;
}

function includePreviousDay(dateTime: DayStartTimeStamp): DayStartTimeStamp {
  return dateTime - MS_IN_DAY;
}

function optionDate(dateTime: DayStartTimeStamp): string {
  return humanizeDate(includePreviousDay(dateTime));
}

function labelDate(dateTime: DayStartTimeStamp): string {
  return formatDate(includePreviousDay(dateTime));
}

function createOptionsList(): Option[] {
  const startTime = getTodayStartTime();
  const options = [];

  for (let daysCount = 1; daysCount < 41; daysCount += 1) {
    const value = startTime + daysCount * MS_IN_DAY;
    const text = `${optionDate(value)} — ${daysCount} ${inclineDays(daysCount)}`;
    options.push({value, text});
  }

  return options;
}

function fallbackFor(selectedDate: DayStartTimeStamp): Option['value'] {
  return selectedDate <= getTodayStartTime() ? selectedDate : 0;
}

interface BudgetDateProps {
  date: DayStartTimeStamp;
}

export const BudgetDate = ({date: selected}: BudgetDateProps): ReactElement => {
  const options = createOptionsList();
  const until = `по ${labelDate(selected)}...`;

  const updateDateWith = useDispatch(changeTemporaryDateAction);
  const changeHandler = (e: React.ChangeEvent<HTMLSelectElement>): void =>
    updateDateWith(+e.target.value);

  return (
    <Section>
      <Row>
        <Prefix>Срок</Prefix>
        <Control data-test='select'>
          <Select text={until} value={selected} onChange={changeHandler}>
            <option disabled value={fallbackFor(selected)}>
              Выберите срок
            </option>

            {options.map(({value, text}: Option) => (
              <option value={value} key={value}>
                {text}
              </option>
            ))}
          </Select>
        </Control>
      </Row>
    </Section>
  );
};
